import React from "react";
import cx from "classnames";
import styles from "./Card.module.scss";
import { Player } from "../players";
import { Image } from "../Image/Image";
import { CircleFlag } from "react-circle-flags";
import { ReactComponent as ArrowRight } from "../ArrowRight.svg";
import bg from "../Bg.svg";

interface Props {
  player: Player;
}

export const Card: React.FunctionComponent<Props> = ({ player }) => {
  return (
    <div className={cx(styles.card)}>
      <div className={styles.body}>
        <div className={styles.header}>
          <div className={styles.team}>
            <CircleFlag
              className={styles.teamFlag}
              countryCode={player.teamCountry}
              height="20"
            />
            {player.team} <ArrowRight />
          </div>
        </div>

        <div className={styles.inner}>
          <div
            className={styles.image}
            style={{
              backgroundImage: `url(${bg})`,
            }}
          >
            <Image src={player.url} ratio={player.ratio} alt={player.alt} />
          </div>

          <div className={cx(styles.footer)}>
            <div className={styles.name}>
              <CircleFlag
                className={styles.teamFlag}
                countryCode={player.country}
                height="30"
              />
              {player.name}{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
